import React from 'react'
import { Link } from 'gatsby'

import * as styles from '../styles/datenlinks.module.scss'

const DatenLinks = () => {
    return (
        <div className={styles.datenLinksContainer}>
            <Link 
                className={styles.datenLink}
                to="/datenschutz">Datenschutz</Link>
            <Link
                className={styles.datenLink}
                to="/impressum">Impressum</Link>
        </div>
    )
}

export default DatenLinks